import React, { useState } from "react";
import { RiEdit2Fill } from "react-icons/ri";
import ButtonWithIcon from "../../../commonComponent/ButtonWithIcon";
import Popup from "../../../commonComponent/Popup";
import { Button } from "react-bootstrap";
import { AiOutlinePlus } from "react-icons/ai";
import CarePlanDescription from "../../carePlan/CarePlanDescription";

export default function AddCarePlanDescription({
  carePlanName,
  carePlanDescription,
  carePlanAssignedBy,
  postData,
  componentType,
  setCarePlanDescription,
  setCarePlanTitle,
  getCarePlanList
}) {
  const [showPopup, setShowPopup] = useState(false);
  const [startDate, setStartDate] = useState("");
  const getList = () =>{
    getCarePlanList()
  }
  const handleSubmitGoal = (e) => {
    e.preventDefault();
    postData({
      name: e.target.elements.title.value,
      description: e.target.elements.description.value,
    });
  };
  return (
    <section>
      <div>
        <p
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Add Care Plan"
          className="btn btn-primary btn-custom ms-2"
          onClick={() => {
            setShowPopup(true);
          }}
        >
          <AiOutlinePlus className="me-2" /> Add Care Plan
        </p>
      </div>
      <Popup
        show={showPopup}
        onHide={() => setShowPopup(false)}
        title={`Add Care Plan Details`}
        content={
          <>
            <CarePlanDescription getCarePlanList={getList} setShowPopup={setShowPopup} />
          </>
        }
        position="top"
        // btn1="Save"
        // btn2="Cancel"
      />
    </section>
  );
}
